var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-37",
    "data-name": "50_Kids_Icons-37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#966796"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4745",
    "data-name": "Group 4745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4729",
    "data-name": "Group 4729",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M145.788,238.491c1.13,2.677.515,5.278-1.374,5.81s-4.337-1.205-5.467-3.882-.515-5.278,1.374-5.811S144.658,235.815,145.788,238.491Z",
    transform: "translate(-116.759 -197.87)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M329.963,238.491c-1.13,2.677-.514,5.278,1.375,5.81s4.337-1.205,5.466-3.882.515-5.278-1.374-5.811S331.094,235.815,329.963,238.491Z",
    transform: "translate(-277.929 -197.87)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4730",
    "data-name": "Group 4730",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M141.568,62.394c0,1.424-1.689,2.664-1.96,4.016-.277,1.383.8,3.176.263,4.461s-2.573,1.8-3.345,2.966-.43,3.228-1.4,4.243-3.043.757-4.179,1.593c-1.116.821-1.493,2.883-2.754,3.522-1.233.625-3.121-.283-4.47.148-1.314.419-2.322,2.258-3.726,2.474-1.36.209-2.875-1.236-4.3-1.236s-2.94,1.445-4.3,1.236c-1.4-.215-2.412-2.054-3.726-2.474-1.349-.431-3.237.477-4.47-.148-1.261-.639-1.638-2.7-2.754-3.522-1.136-.836-3.218-.591-4.179-1.593s-.635-3.082-1.4-4.243-2.807-1.674-3.345-2.966.54-3.078.263-4.461c-.271-1.352-1.96-2.592-1.96-4.016s1.689-2.664,1.96-4.016c.277-1.383-.8-3.176-.263-4.461s2.573-1.8,3.345-2.966.43-3.228,1.4-4.243,3.043-.757,4.179-1.593c1.116-.821,1.493-2.883,2.754-3.522,1.233-.625,3.121.282,4.47-.148,1.314-.419,2.322-2.258,3.726-2.473,1.36-.209,2.875,1.236,4.3,1.236s2.94-1.445,4.3-1.236c1.4.215,2.412,2.054,3.726,2.473,1.349.431,3.237-.477,4.47.148,1.261.639,1.638,2.7,2.754,3.522,1.136.836,3.218.591,4.179,1.593s.635,3.082,1.4,4.243,2.807,1.674,3.345,2.966-.54,3.078-.263,4.461C139.879,59.73,141.568,60.97,141.568,62.394Z",
    transform: "translate(-75.786 -32.863)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4731",
    "data-name": "Group 4731",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M118.724,421.249l-.009-.145c0-8.821-3.3-17.367-7.334-18.995l-17.171-6.918a22.748,22.748,0,0,0-14.668-.019l-17.417,6.959c-4.035,1.615-7.337,10.152-7.337,18.973l-.009.145Z",
    transform: "translate(-46.219 -332.409)",
    fill: "#a34322"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4732",
    "data-name": "Group 4732",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M227.408,272.134a6.856,6.856,0,0,1-6.856,6.856h-.831a6.856,6.856,0,0,1-6.856-6.856v-17.66a6.856,6.856,0,0,1,6.856-6.856h.831a6.856,6.856,0,0,1,6.856,6.856Z",
    transform: "translate(-179.605 -208.928)",
    fill: "#a34322"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4734",
    "data-name": "Group 4734",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4733",
    "data-name": "Group 4733",
    transform: "translate(25.777 14.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M194.48,121.524a14.755,14.755,0,0,1-14.755,14.755h0a14.755,14.755,0,0,1-14.755-14.755V109.251A14.755,14.755,0,0,1,179.725,94.5h0a14.755,14.755,0,0,1,14.755,14.755Z",
    transform: "translate(-164.97 -94.496)",
    fill: "#b87240"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4735",
    "data-name": "Group 4735",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 1.706,
    cy: 1.706,
    r: 1.706,
    transform: "translate(33.168 38.438)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    cx: 1.706,
    cy: 1.706,
    r: 1.706,
    transform: "translate(44.483 38.438)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4736",
    "data-name": "Group 4736",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M165.869,79.272c-9.566,0-17.321,8.405-17.321,18.774a19.9,19.9,0,0,0,2.349,9.444l1.066-9.04A6.291,6.291,0,0,1,158.21,92.9h15.315a6.291,6.291,0,0,1,6.248,5.553l1.068,9.042a19.9,19.9,0,0,0,2.348-9.444C183.19,87.677,175.435,79.272,165.869,79.272Z",
    transform: "translate(-125.337 -66.886)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4737",
    "data-name": "Group 4737",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M246.649,274.928a2.628,2.628,0,0,1-5.13.593,2.782,2.782,0,0,0-.126.783,2.814,2.814,0,1,0,5.629,0A2.776,2.776,0,0,0,246.649,274.928Z",
    transform: "translate(-203.675 -231.971)",
    fill: "#a34322"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4738",
    "data-name": "Group 4738",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M118.714,435.37c0-8.821-3.3-17.367-7.334-18.995l-13.653-5.5a12.058,12.058,0,0,1-21.928.058L62.123,416.4c-4.035,1.615-7.337,10.152-7.337,18.973l-.009.145h63.946Z",
    transform: "translate(-46.218 -346.676)",
    fill: "#2961a5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4740",
    "data-name": "Group 4740",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4739",
    "data-name": "Group 4739",
    transform: "translate(34.608 48.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M221.494,307.432c0,.032,0,.068,0,.1a5.924,5.924,0,1,0,11.847,0c0-.034,0-.07,0-.1Z",
    transform: "translate(-221.492 -307.432)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M233.541,307.432v.507a1.86,1.86,0,0,0,1.86,1.862h6.094a1.861,1.861,0,0,0,1.863-1.862v-.507Z",
    transform: "translate(-231.658 -307.432)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4741",
    "data-name": "Group 4741",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M150.328,151.906h0a3.828,3.828,0,0,1-3.828-3.828v-8.75a3.828,3.828,0,0,1,3.828-3.828h0a3.828,3.828,0,0,1,3.828,3.828v8.75A3.828,3.828,0,0,1,150.328,151.906Z",
    transform: "translate(-123.609 -114.328)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M192.572,104.093h0a4.339,4.339,0,0,1-4.339-4.339V89.838a4.339,4.339,0,0,1,4.339-4.339h0a4.339,4.339,0,0,1,4.339,4.339v9.917A4.339,4.339,0,0,1,192.572,104.093Z",
    transform: "translate(-158.822 -72.14)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M237.572,95.093h0a4.339,4.339,0,0,1-4.339-4.339V80.838a4.339,4.339,0,0,1,4.339-4.339h0a4.339,4.339,0,0,1,4.339,4.339v9.917A4.339,4.339,0,0,1,237.572,95.093Z",
    transform: "translate(-196.79 -64.546)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M282.572,105.093h0a4.339,4.339,0,0,1-4.339-4.339V90.838a4.339,4.339,0,0,1,4.339-4.339h0a4.339,4.339,0,0,1,4.339,4.339v9.917A4.339,4.339,0,0,1,282.572,105.093Z",
    transform: "translate(-234.759 -72.984)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M330.328,146.906h0a3.828,3.828,0,0,1-3.828-3.828v-8.75a3.828,3.828,0,0,1,3.828-3.828h0a3.828,3.828,0,0,1,3.828,3.828v8.75A3.828,3.828,0,0,1,330.328,146.906Z",
    transform: "translate(-275.484 -110.109)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_256",
    "data-name": "Ellipse 256",
    cx: 15.625,
    cy: 6.25,
    rx: 15.625,
    ry: 6.25,
    transform: "translate(24.453 14.141)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4744",
    "data-name": "Group 4744",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4742",
    "data-name": "Group 4742",
    transform: "translate(31.94 35.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M205.658,228.316a7.11,7.11,0,0,1,3.356-.68.817.817,0,0,0,0-1.633,8.857,8.857,0,0,0-4.18.9c-.942.47-.115,1.879.824,1.41Z",
    transform: "translate(-204.419 -226)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4743",
    "data-name": "Group 4743",
    transform: "translate(43.743 35.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M284.1,228.316a7.109,7.109,0,0,0-3.356-.68.817.817,0,0,1,0-1.633,8.856,8.856,0,0,1,4.18.9c.942.47.115,1.879-.824,1.41Z",
    transform: "translate(-279.954 -226)",
    fill: "#3d2a3d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar18);
export default __webpack_public_path__ + "static/media/avatar18.25b93ce76cfcf1256c4f62099d9f6035.svg";
export { ForwardRef as ReactComponent };